module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Light.3357994e.woff2";